import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './assets/site.css'

// AppleID SDK não carrega em dev local (requer HTTPS + domínio cadastrado)
if (!(window as any).AppleID) {
    (window as any).AppleID = { auth: { init: () => {}, signIn: () => Promise.reject('not available') } };
}

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
